import { useContext } from 'react'
import { DropdownMenu as RadMenu } from 'radix-ui'
import useLogout from '@/app-services/useLogout'
import { env } from '@/services/EnvironmentVariables'
import { Button } from '@/UIComponents2/Button'
import { useUserContext } from '@/UserContext'
import { cn } from '@/utlis/cn'
import { Gravatar } from './Gravatar'
import { AppSettingsPageMenuType, useAppContext } from '@/AppContext'
import { useTranslation } from 'react-i18next'
import { Username } from './Username'
import { PortalContext } from '@/UIComponents2/PortalContext'
import '@/components/dropdown-animation.css'

type UserProfilePopoverProps = {
    children?: React.ReactNode
    className?: string
}
export const UserProfilePopover = (props: UserProfilePopoverProps) => {
    const { t } = useTranslation()
    const [, appDispatch] = useAppContext()
    const [userState] = useUserContext()
    const { logout } = useLogout()
    const portalContainer = useContext(PortalContext)

    const openAboutDialog = ({ startingPage }: { startingPage: AppSettingsPageMenuType }) => {
        appDispatch({
            type: 'update_app_state',
            value: { showAboutDialog: { startingPage } },
        })
    }

    const layout = 'flex flex-col max-h-[70vh]'
    const style = 'min-w-[270px] py-4 bg-white/5 z-30'
    const border = 'border-1 border-white/10 rounded-[20px]'
    const bg = 'bg-no-repeat bg-[#3A3A3A]'
    return (
        <RadMenu.Root modal={false}>
            <RadMenu.Trigger asChild>{props.children}</RadMenu.Trigger>
            <RadMenu.Portal container={portalContainer}>
                <RadMenu.Content
                    className={cn('dropdown-menu-content', layout, style, border, bg, props.className)}
                    sideOffset={5}
                >
                    <RadMenu.Item asChild>
                        <Button
                            className="flex items-center gap-4 hover:bg-white/10 px-4 py-2 text-left"
                            onClick={() => openAboutDialog({ startingPage: 'account' })}
                        >
                            <div>
                                <div className="flex items-center justify-center w-[40px] h-[40px] rounded-full bg-white/20">
                                    <Gravatar email={userState.userUrn} className="w-[40px] h-[40px]" />
                                </div>
                            </div>
                            <div>
                                <div className="t-lg-medium text-[#FCDD40]">
                                    <Username isMe />
                                </div>
                                <div className="t-base-light opacity-60">{userState.profile?.email}</div>
                            </div>
                        </Button>
                    </RadMenu.Item>

                    <RadMenu.Item asChild>
                        <Button
                            className="hover:bg-white/10 t-base-medium px-4 py-2 text-left"
                            onClick={() => openAboutDialog({ startingPage: 'about' })}
                        >
                            {t('Help')}
                        </Button>
                    </RadMenu.Item>

                    <RadMenu.Item asChild>
                        <Button
                            className="hover:bg-white/10 t-base-medium px-4 py-2 text-left"
                            onClick={() => logout()}
                        >
                            {t('Log out')}
                        </Button>
                    </RadMenu.Item>

                    <div className="t-sm-light opacity-40 px-4 pt-2">
                        plan <span className="font-medium">{userState.profile?.policy?._id}</span> on Muse{' '}
                        <span className="font-medium">{env.APP_VERSION}</span>
                    </div>
                </RadMenu.Content>
            </RadMenu.Portal>
        </RadMenu.Root>
    )
}
